var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buttonTable"},[_c('el-tooltip',{attrs:{"effect":"light","content":_vm.content,"placement":"bottom"}},[_c('el-button',{style:({
      color: _vm.iconClolor
    }),attrs:{"type":"text","size":"small"},nativeOn:{"click":function($event){return _vm.btnClick.apply(null, arguments)}}},[_c('i',{class:_vm.icon})])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }